import { createContext, SetStateAction, useContext, useState } from "react";

interface LoginContextType {
  email: string;
  userName: string;
  twoStepAuthCode: string;
  twoStepReleaseCode: string;
  twoStepSetCode: string;
  additionalParams: string;
  soriId: string;
  setEmail: React.Dispatch<SetStateAction<string>>;
  setUserName: React.Dispatch<SetStateAction<string>>;
  setTwoStepAuthCode: React.Dispatch<SetStateAction<string>>;
  setTwoStepReleaseCode: React.Dispatch<SetStateAction<string>>;
  setTwoStepSetCode: React.Dispatch<SetStateAction<string>>;
  setAdditionalParams: React.Dispatch<SetStateAction<string>>;
  setSoriId: React.Dispatch<SetStateAction<string>>;
}

const LoginContext = createContext<LoginContextType | undefined>(undefined);

export const LoginProvider = ({children}: {children: React.ReactNode}) => {
  const [email, setEmail] = useState("");
  const [userName, setUserName] = useState("");
  const [twoStepAuthCode, setTwoStepAuthCode] = useState("");
  const [twoStepReleaseCode, setTwoStepReleaseCode] = useState("");
  const [twoStepSetCode, setTwoStepSetCode] = useState("");
  const [additionalParams, setAdditionalParams] = useState("");
  const [soriId, setSoriId] = useState("");

  const ch = new BroadcastChannel("app-events");
  ch.addEventListener('message', (ev) => {
    setSoriId(ev.data.soriId);
  });

  return (
    <LoginContext.Provider
      value={{
        email,
        userName,
        twoStepAuthCode,
        twoStepReleaseCode,
        twoStepSetCode,
        additionalParams,
        soriId,
        setEmail,
        setUserName,
        setTwoStepAuthCode,
        setTwoStepReleaseCode,
        setTwoStepSetCode,
        setAdditionalParams,
        setSoriId,
      }}
    >
      {children}
    </LoginContext.Provider>
  );
};

export const useLoginContext = () => {
  const context = useContext(LoginContext);
  if (!context) throw new Error("useLoginContext must be used within LoginProvider");
  return context;
};